
 const Apiurl = 'https://backend.mindprint.ru';
//const Apiurl = 'http://localhost:1805';
export default Apiurl
